import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Navbar, Nav, Card, Button, Row, Col, Carousel, Modal, Form, Badge, ProgressBar } from 'react-bootstrap';

const NEETMedicalPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  const courses = [
    {
      id: 1,
      title: 'NEET Complete Preparation',
      description: 'Comprehensive course covering Physics, Chemistry & Biology for NEET aspirants',
      rating: 4.8,
      students: 15200,
      price: '₹12,999',
      image: 'https://via.placeholder.com/300x200'
    },
    {
      id: 2,
      title: 'Biology Masterclass',
      description: 'Deep dive into Botany and Zoology concepts with expert faculty',
      rating: 4.9,
      students: 10500,
      price: '₹8,499',
      image: 'https://via.placeholder.com/300x200'
    },
    {
      id: 3,
      title: 'Physics & Chemistry Bundle',
      description: 'Master the core concepts and problem-solving techniques',
      rating: 4.7,
      students: 9800,
      price: '₹9,999',
      image: 'https://via.placeholder.com/300x200'
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: 'Priya Sharma',
      rank: 'AIR 145',
      college: 'AIIMS Delhi',
      content: 'The structured approach and regular mock tests helped me secure my dream college.',
      image: 'https://via.placeholder.com/100x100'
    },
    {
      id: 2,
      name: 'Rahul Kumar',
      rank: 'AIR 278',
      college: 'JIPMER',
      content: 'The faculty mentorship and doubt clearing sessions were invaluable in my preparation.',
      image: 'https://via.placeholder.com/100x100'
    },
    {
      id: 3,
      name: 'Ananya Patel',
      rank: 'AIR 56',
      college: 'AIIMS Delhi',
      content: 'The comprehensive study material and test series gave me an edge over others.',
      image: 'https://via.placeholder.com/100x100'
    }
  ];

  const upcomingEvents = [
    {
      id: 1,
      title: 'NEET 2025 Strategy Webinar',
      date: 'March 25, 2025',
      time: '5:00 PM IST',
      speaker: 'Dr. Rajesh Mehta, Former AIIMS Director'
    },
    {
      id: 2,
      title: 'Biology Marathon: 100 Topics in 4 Hours',
      date: 'April 2, 2025',
      time: '3:00 PM IST',
      speaker: 'Prof. Sunita Verma, HOD Biology'
    },
    {
      id: 3,
      title: 'NEET Previous Year Question Analysis',
      date: 'April 10, 2025',
      time: '6:00 PM IST',
      speaker: 'Dr. Amit Singh, 15+ years NEET expert'
    }
  ];

  return (
    <div className="neet-medical-page sticky-top mt-4 py-4">
   
      {/* Hero Section */}
      <section className="bg-white text-white py-5">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <h1 className="display-4 fw-bold mb-3">Ace Your NEET 2025 Exam</h1>
              <p className="lead mb-4">
                Join India's leading medical entrance preparation platform with 98.5% selection rate in top medical colleges
              </p>
              <div className="d-flex gap-2 flex-wrap">
                <Button variant="light" size="lg" className="fw-bold text-primary">
                  Start Free Trial
                </Button>
                <Button variant="outline-light" size="lg">
                  <i className="far fa-play-circle me-2"></i> Watch Demo
                </Button>
              </div>
              <div className="mt-4 d-flex align-items-center">
                <span className="me-3">
                  <i className="fas fa-star text-warning"></i>
                  <i className="fas fa-star text-warning"></i>
                  <i className="fas fa-star text-warning"></i>
                  <i className="fas fa-star text-warning"></i>
                  <i className="fas fa-star-half-alt text-warning"></i>
                  <span className="ms-2 text-white">4.8/5</span>
                </span>
                <span className="border-start ps-3">50,000+ successful students</span>
              </div>
            </Col>
            <Col md={6} className="mt-4 mt-md-0">
              <Card className="border-0 shadow">
                <Card.Body className="p-4">
                  <h3 className="text-primary mb-3">Book a Free Counseling Session</h3>
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Control type="text" placeholder="Your Name" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Control type="email" placeholder="Email Address" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Control type="tel" placeholder="Phone Number" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Select>
                        <option>Select Your Grade</option>
                        <option>Class 11</option>
                        <option>Class 12</option>
                        <option>Dropper (Gap Year)</option>
                      </Form.Select>
                    </Form.Group>
                    <Button variant="primary" className="w-100 py-2">
                      Schedule Free Counseling
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section className="py-5 bg-light">
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-bold">Why Choose Our NEET Program?</h2>
            <p className="text-muted">Comprehensive preparation strategy designed by NEET experts</p>
          </div>
          <Row className="g-4">
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="p-4 text-center">
                  <div className="rounded-circle bg-primary bg-opacity-10 p-3 d-inline-flex mb-3">
                    <i className="fas fa-user-md text-primary fa-2x"></i>
                  </div>
                  <h4>Expert Faculty</h4>
                  <p className="text-muted">Learn from doctors and top educators with proven track record</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="p-4 text-center">
                  <div className="rounded-circle bg-primary bg-opacity-10 p-3 d-inline-flex mb-3">
                    <i className="fas fa-book-open text-primary fa-2x"></i>
                  </div>
                  <h4>Comprehensive Material</h4>
                  <p className="text-muted">Updated study resources aligned with latest NEET pattern</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="p-4 text-center">
                  <div className="rounded-circle bg-primary bg-opacity-10 p-3 d-inline-flex mb-3">
                    <i className="fas fa-flask text-primary fa-2x"></i>
                  </div>
                  <h4>Personalized Learning</h4>
                  <p className="text-muted">AI-driven performance analysis and customized study plan</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Courses Section */}
      <section className="py-5" id="courses">
        <Container>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold mb-1">Our NEET Courses</h2>
              <p className="text-muted">Designed to help you ace your medical entrance exam</p>
            </div>
            <Button variant="outline-primary">View All Courses</Button>
          </div>
          <Row className="g-4">
            {courses.map(course => (
              <Col md={4} key={course.id}>
                <Card className="h-100 border-0 shadow-sm">
                  <div className="position-relative">
                    <Card.Img variant="top" src={course.image} />
                    <Badge bg="danger" className="position-absolute top-0 end-0 m-2">Bestseller</Badge>
                  </div>
                  <Card.Body className="p-4">
                    <div className="d-flex justify-content-between mb-2">
                      <Badge bg="primary" className="bg-opacity-10 text-primary">NEET 2025</Badge>
                      <div>
                        <i className="fas fa-star text-warning"></i>
                        <span className="ms-1">{course.rating}</span>
                      </div>
                    </div>
                    <Card.Title className="fw-bold">{course.title}</Card.Title>
                    <Card.Text className="text-muted">{course.description}</Card.Text>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <span className="fw-bold text-primary">{course.price}</span>
                      <Button variant="primary">Enroll Now</Button>
                    </div>
                  </Card.Body>
                  <Card.Footer className="bg-white border-0 p-4 pt-0">
                    <small className="text-muted">
                      <i className="fas fa-users me-2"></i>
                      {course.students.toLocaleString()} students enrolled
                    </small>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Success Stories */}
      <section className="py-5 bg-light" id="success-stories">
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-bold">Success Stories</h2>
            <p className="text-muted">Our students who cracked NEET with top ranks</p>
          </div>
          <Carousel indicators={false}>
            <Carousel.Item>
              <Row className="justify-content-center">
                {testimonials.map(testimonial => (
                  <Col md={4} key={testimonial.id}>
                    <Card className="h-100 border-0 shadow-sm">
                      <Card.Body className="p-4">
                        <div className="d-flex mb-3">
                          <img
                            src={testimonial.image}
                            alt={testimonial.name}
                            className="rounded-circle"
                            width="60"
                            height="60"
                          />
                          <div className="ms-3">
                            <h5 className="mb-0 fw-bold">{testimonial.name}</h5>
                            <div className="text-primary">Rank: {testimonial.rank}</div>
                            <div className="text-muted small">{testimonial.college}</div>
                          </div>
                        </div>
                        <p className="mb-0">{testimonial.content}</p>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          </Carousel>
        </Container>
      </section>

      {/* Statistics */}
      <section className="py-5 bg-primary text-white">
        <Container>
          <Row className="text-center">
            <Col md={3} className="mb-4 mb-md-0">
              <h2 className="display-4 fw-bold">98.5%</h2>
              <p>Selection Rate</p>
            </Col>
            <Col md={3} className="mb-4 mb-md-0">
              <h2 className="display-4 fw-bold">500+</h2>
              <p>AIIMS & JIPMER Selections</p>
            </Col>
            <Col md={3} className="mb-4 mb-md-0">
              <h2 className="display-4 fw-bold">15+</h2>
              <p>Years of Excellence</p>
            </Col>
            <Col md={3}>
              <h2 className="display-4 fw-bold">50K+</h2>
              <p>Students Enrolled</p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Upcoming Events */}
      <section className="py-5">
        <Container>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold mb-1">Upcoming Free Webinars</h2>
              <p className="text-muted">Join live sessions with NEET experts</p>
            </div>
            <Button variant="outline-primary">View All Events</Button>
          </div>
          <Row className="g-4">
            {upcomingEvents.map(event => (
              <Col md={4} key={event.id}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-primary bg-opacity-10 rounded p-3 me-3">
                        <i className="fas fa-calendar-alt text-primary fa-2x"></i>
                      </div>
                      <div>
                        <h6 className="mb-0">{event.date}</h6>
                        <small className="text-muted">{event.time}</small>
                      </div>
                    </div>
                    <h5 className="fw-bold">{event.title}</h5>
                    <p className="text-muted">Speaker: {event.speaker}</p>
                    <Button variant="primary" className="w-100">Register Now</Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* NEET Information */}
      <section className="py-5 bg-light">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto">
              <Card className="border-0 shadow-sm">
                <Card.Header className="bg-white p-0 border-0">
                  <Nav variant="tabs" className="nav-fill">
                    <Nav.Item>
                      <Nav.Link 
                        className={activeTab === 'overview' ? 'active' : ''} 
                        onClick={() => setActiveTab('overview')}
                      >
                        NEET Overview
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link 
                        className={activeTab === 'syllabus' ? 'active' : ''} 
                        onClick={() => setActiveTab('syllabus')}
                      >
                        Syllabus
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link 
                        className={activeTab === 'timeline' ? 'active' : ''} 
                        onClick={() => setActiveTab('timeline')}
                      >
                        Timeline
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link 
                        className={activeTab === 'strategy' ? 'active' : ''} 
                        onClick={() => setActiveTab('strategy')}
                      >
                        Strategy
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Card.Header>
                <Card.Body className="p-4">
                  {activeTab === 'overview' && (
                    <div>
                      <h4 className="fw-bold mb-3">NEET 2025 Exam Overview</h4>
                      <p>The National Eligibility cum Entrance Test (NEET) is the qualifying entrance exam for MBBS and BDS programs in Indian medical and dental colleges. NEET is conducted by the National Testing Agency (NTA).</p>
                      <div className="bg-light p-3 rounded mb-3">
                        <h6 className="fw-bold">Exam Pattern</h6>
                        <p className="mb-2">NEET consists of 180 multiple-choice questions from Physics, Chemistry, and Biology (Botany & Zoology).</p>
                        <ul className="mb-0">
                          <li>Physics: 45 questions</li>
                          <li>Chemistry: 45 questions</li>
                          <li>Biology (Botany & Zoology): 90 questions</li>
                        </ul>
                      </div>
                      <div className="bg-light p-3 rounded">
                        <h6 className="fw-bold">Marking Scheme</h6>
                        <ul className="mb-0">
                          <li>Correct Answer: +4 marks</li>
                          <li>Incorrect Answer: -1 mark</li>
                          <li>Unattempted Question: 0 marks</li>
                        </ul>
                      </div>
                    </div>
                  )}
                  {activeTab === 'syllabus' && (
                    <div>
                      <h4 className="fw-bold mb-3">NEET 2025 Syllabus</h4>
                      <div className="accordion" id="syllabusAccordion">
                        <div className="accordion-item border-0 mb-3">
                          <h2 className="accordion-header">
                            <button className="accordion-button bg-light" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePhysics">
                              Physics
                            </button>
                          </h2>
                          <div id="collapsePhysics" className="accordion-collapse collapse show">
                            <div className="accordion-body">
                              <p>The syllabus includes topics from Class 11 & 12 Physics:</p>
                              <ul>
                                <li>Physical World & Measurement</li>
                                <li>Kinematics</li>
                                <li>Laws of Motion</li>
                                <li>Work, Energy & Power</li>
                                <li>Thermodynamics</li>
                                <li>Electrostatics</li>
                                <li>Current Electricity</li>
                                <li>Magnetic Effects of Current</li>
                                <li>Optics</li>
                                <li>Modern Physics</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item border-0 mb-3">
                          <h2 className="accordion-header">
                            <button className="accordion-button collapsed bg-light" type="button" data-bs-toggle="collapse" data-bs-target="#collapseChemistry">
                              Chemistry
                            </button>
                          </h2>
                          <div id="collapseChemistry" className="accordion-collapse collapse">
                            <div className="accordion-body">
                              <p>The syllabus includes topics from Class 11 & 12 Chemistry:</p>
                              <ul>
                                <li>Basic Concepts of Chemistry</li>
                                <li>Structure of Atom</li>
                                <li>Chemical Bonding</li>
                                <li>States of Matter</li>
                                <li>Thermodynamics</li>
                                <li>Equilibrium</li>
                                <li>Redox Reactions</li>
                                <li>Organic Chemistry Basics</li>
                                <li>Hydrocarbons</li>
                                <li>Coordination Compounds</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item border-0">
                          <h2 className="accordion-header">
                            <button className="accordion-button collapsed bg-light" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBiology">
                              Biology
                            </button>
                          </h2>
                          <div id="collapseBiology" className="accordion-collapse collapse">
                            <div className="accordion-body">
                              <p>The syllabus includes topics from Class 11 & 12 Biology:</p>
                              <ul>
                                <li>Diversity in Living World</li>
                                <li>Cell Structure and Function</li>
                                <li>Human Physiology</li>
                                <li>Plant Physiology</li>
                                <li>Genetics and Evolution</li>
                                <li>Biology and Human Welfare</li>
                                <li>Biotechnology</li>
                                <li>Ecology and Environment</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {activeTab === 'timeline' && (
                    <div>
                      <h4 className="fw-bold mb-3">NEET 2025 Timeline</h4>
                      <div className="position-relative pt-3">
                        <div className="position-absolute top-0 bottom-0 start-0 ms-3 border-start border-2 border-primary" style={{ width: '1px' }}></div>
                        
                        <div className="d-flex mb-4 position-relative">
                          <div className="bg-primary rounded-circle p-2 me-3 z-1"></div>
                          <div>
                            <h6 className="fw-bold">November 2024</h6>
                            <p className="mb-0">Application Form Release</p>
                          </div>
                        </div>
                        
                        <div className="d-flex mb-4 position-relative">
                          <div className="bg-primary rounded-circle p-2 me-3 z-1"></div>
                          <div>
                            <h6 className="fw-bold">January 2025</h6>
                            <p className="mb-0">Last Date for Application Submission</p>
                          </div>
                        </div>
                        
                        <div className="d-flex mb-4 position-relative">
                          <div className="bg-primary rounded-circle p-2 me-3 z-1"></div>
                          <div>
                            <h6 className="fw-bold">April 2025</h6>
                            <p className="mb-0">Admit Card Release</p>
                          </div>
                        </div>
                        
                        <div className="d-flex mb-4 position-relative">
                          <div className="bg-primary rounded-circle p-2 me-3 z-1"></div>
                          <div>
                            <h6 className="fw-bold">May 2025</h6>
                            <p className="mb-0">NEET 2025 Exam Date</p>
                          </div>
                        </div>
                        
                        <div className="d-flex position-relative">
                          <div className="bg-primary rounded-circle p-2 me-3 z-1"></div>
                          <div>
                            <h6 className="fw-bold">June 2025</h6>
                            <p className="mb-0">Result Declaration</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {activeTab === 'strategy' && (
                    <div>
                      <h4 className="fw-bold mb-3">NEET 2025 Preparation Strategy</h4>
                      <div className="bg-light p-3 rounded mb-3">
                        <h6 className="fw-bold">Time Management</h6>
                        <p>Allocate your study hours effectively between Physics, Chemistry, and Biology based on your strengths and weaknesses.</p>
                      </div>
                      <div className="bg-light p-3 rounded mb-3">
                        <h6 className="fw-bold">Topic Prioritization</h6>
                        <p>Focus on high-yield topics that appear frequently in NEET:</p>
                        <ul>
                          <li>Biology: Human Physiology, Genetics, Ecology</li>
                          <li>Chemistry: Organic Chemistry, Chemical Equilibrium</li>
                          <li>Physics: Mechanics, Electrostatics, Optics</li>
                        </ul>
                      </div>
                      <div className="bg-light p-3 rounded">
                        <h6 className="fw-bold">Mock Tests</h6>
                        <p className="mb-0">Take regular mock tests to improve speed, accuracy, and time management. Analyze each test to identify and work on weak areas.</p>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Study Plan */}
      <section className="py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2 className="fw-bold mb-3">Your Personalized NEET Study Plan</h2>
              <p className="mb-4">Our AI-driven study planner creates a customized schedule based on your strengths, weaknesses, and available study hours.</p>
              
              <div className="mb-4">
                <h5 className="mb-2">Subject-wise Progress</h5>
                <div className="mb-3">
                  <div className="d-flex justify-content-between mb-1">
                    <span>Physics</span>
                    <span>65%</span>
                  </div>
                  <ProgressBar now={65} variant="danger" />
                </div>
                <div className="mb-3">
                  <div className="d-flex justify-content-between mb-1">
                    <span>Chemistry</span>
                    <span>78%</span>
                  </div>
                  <ProgressBar now={78} variant="warning" />
                </div>
                <div>
                  <div className="d-flex justify-content-between mb-1">
                    <span>Biology</span>
                    <span>82%</span>
                  </div>
                  <ProgressBar now={82} variant="success" />
                </div>
              </div>
              
              <Button variant="primary" size="lg">
                Create Your Study Plan
              </Button>
            </Col>
            <Col lg={6}>
              <Card className="border-0 shadow-sm">
                <Card.Body className="p-4">
                  <h4 className="fw-bold mb-3">Sample Daily Schedule</h4>
                  <div className="bg-light p-3 rounded mb-3">
                    <div className="d-flex justify-content-between mb-2">
                      <span className="fw-bold">6:00 AM - 8:00 AM</span>
                      <Badge bg="primary">Physics</Badge>
                    </div>
                    <p className="mb-0 small">Mechanics: Laws of Motion and Problem Solving</p>
                  </div>
                  <div className="bg-light p-3 rounded mb-3">
                    <div className="d-flex justify-content-between mb-2">
                      <span className="fw-bold">9:00 AM - 11:00 AM</span>
                      <Badge bg="success">Biology</Badge>
                    </div>
                    <p className="mb-0 small">Human Physiology: Digestive System</p>
                  </div>
                  <div className="bg-light p-3 rounded mb-3">
                    <div className="d-flex justify-content-between mb-2">
                      <span className="fw-bold">2:00 PM - 4:00 PM</span>
                      <Badge bg="warning">Chemistry</Badge>
                    </div>
                    <p className="mb-0 small">Organic Chemistry: Alcohol, Phenol and Ether</p>
                  </div>
                  <div className="bg-light p-3 rounded">
                    <div className="d-flex justify-content-between mb-2">
                      <span className="fw-bold">5:00 PM - 7:00 PM</span>
                      <Badge bg="info">Revision</Badge>
                    </div>
                    <p className="mb-0 small">Mock Test and Analysis</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA */}
      <section className="py-5 bg-primary text-white">
  <Container className="text-center">
    <h2 className="fw-bold mb-4">Ready to Begin Your NEET Journey?</h2>
    <p className="lead mb-4">Join thousands of successful medical aspirants who achieved their dreams with our expert guidance</p>
    <Button variant="light" size="lg" className="fw-bold text-primary me-3">
      Get Started Now
    </Button>
    <Button variant="outline-light" size="lg">
      Schedule a Demo
    </Button>
  </Container>
</section>

{/* FAQ Section */}
<section className="py-5 bg-light">
  <Container>
    <div className="text-center mb-5">
      <h2 className="fw-bold">Frequently Asked Questions</h2>
      <p className="text-muted">Find answers to common questions about NEET and our programs</p>
    </div>
    <Row className="justify-content-center">
      <Col lg={8}>
        <div className="accordion" id="faqAccordion">
          <div className="accordion-item mb-3 border-0 shadow-sm">
            <h2 className="accordion-header">
              <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
                How is NEET Excellence different from other coaching institutes?
              </button>
            </h2>
            <div id="faq1" className="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                NEET Excellence stands out with its personalized learning approach, AI-driven performance analysis, and faculty comprising doctors and top NEET educators. Our 98.5% selection rate and consistent top ranks by our students demonstrate our effectiveness.
              </div>
            </div>
          </div>
          
          <div className="accordion-item mb-3 border-0 shadow-sm">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
                Can I access the courses on mobile devices?
              </button>
            </h2>
            <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Yes, all our courses are fully compatible with smartphones and tablets. Our mobile app is available on both Android and iOS platforms, allowing you to study anytime, anywhere.
              </div>
            </div>
          </div>
          
          <div className="accordion-item mb-3 border-0 shadow-sm">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
                How many mock tests are included in the courses?
              </button>
            </h2>
            <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Our comprehensive courses include 120+ topic-wise tests, 30+ subject-wise tests, and 15+ full-length mock tests designed as per the latest NEET pattern. Each test comes with detailed analysis and performance improvement suggestions.
              </div>
            </div>
          </div>
          
          <div className="accordion-item border-0 shadow-sm">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
                Is there a refund policy if I'm not satisfied with the course?
              </button>
            </h2>
            <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
              <div className="accordion-body">
                Yes, we offer a 7-day money-back guarantee for all our courses. If you're not satisfied with the course content or teaching methodology, you can request a full refund within the first 7 days of purchase.
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </Container>
</section>

{/* Registration Modal */}
<Modal show={showModal} onHide={handleCloseModal} centered size="lg">
  <Modal.Header closeButton>
    <Modal.Title className="fw-bold">Register for NEET Excellence</Modal.Title>
  </Modal.Header>
  <Modal.Body className="p-4">
    <Row>
      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>Full Name</Form.Label>
          <Form.Control type="text" placeholder="Enter your full name" />
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>Email Address</Form.Label>
          <Form.Control type="email" placeholder="Enter your email" />
        </Form.Group>
      </Col>
    </Row>
    <Row>
      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>Phone Number</Form.Label>
          <Form.Control type="tel" placeholder="Enter your phone number" />
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>Current Grade</Form.Label>
          <Form.Select>
            <option>Select your grade</option>
            <option>Class 11</option>
            <option>Class 12</option>
            <option>Dropper (Gap Year)</option>
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>
    <Form.Group className="mb-3">
      <Form.Label>City</Form.Label>
      <Form.Control type="text" placeholder="Enter your city" />
    </Form.Group>
    <Form.Group className="mb-3">
      <Form.Label>Preferred Course</Form.Label>
      <Form.Select>
        <option>Select a course</option>
        <option>NEET Complete Preparation</option>
        <option>Biology Masterclass</option>
        <option>Physics & Chemistry Bundle</option>
        <option>Test Series Only</option>
        <option>Mentorship Program</option>
      </Form.Select>
    </Form.Group>
    <Form.Group className="mb-3">
      <Form.Check 
        type="checkbox"
        id="termsCheck"
        label="I agree to the terms and conditions and privacy policy"
      />
    </Form.Group>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={handleCloseModal}>
      Cancel
    </Button>
    <Button variant="primary">
      Register Now
    </Button>
  </Modal.Footer>
</Modal>
</div>
  );
};

export default NEETMedicalPage;